// extracted by mini-css-extract-plugin
export var active = "_hk-7";
export var blink = "_hk-8";
export var dropDownSelector = "_hk-4";
export var dropDownWrapper = "_hk-3";
export var fakeCursor = "_hk-6";
export var fontSizeButton = "_hk-9";
export var formQuillEditor = "_hk-0";
export var pressed = "_hk-a";
export var qlBlank = "_hk-1";
export var textFormattingToolbar = "_hk-2";
export var textToolbarOption = "_hk-5";